import React from 'react';
import { pr } from './helpers';
import {
  AdminDashboardPage,
  CompaniesPage,
  DemoRequestsPage,
  PlansPage,
  CountriesPage,
  DbExplorerPage,
  AgentMemoryPage,
  CurrenciesPage,
  LabelDesignerPage,
  ReportDesignerPage,
  WorkflowDesignerPage,
  NotificationsPage,
} from '../lazyPages';

const ADMIN = ['system_admin'];

/** All /admin/* protected routes — mounted on admin subdomain, company subdomain, and apex. */
export function AdminProtectedRoutes() {
  return (
    <>
      {pr('/admin', AdminDashboardPage, ADMIN)}
      {pr('/admin/companies', CompaniesPage, ADMIN)}
      {pr('/admin/demo-requests', DemoRequestsPage, ADMIN)}
      {pr('/admin/notifications', NotificationsPage, ADMIN)}
      {pr('/admin/plans', PlansPage, ADMIN)}
      {pr('/admin/countries', CountriesPage, ADMIN)}
      {pr('/admin/db-explorer', DbExplorerPage, ADMIN)}
      {pr('/admin/agent-memory', AgentMemoryPage, ADMIN)}
      {pr('/admin/currencies', CurrenciesPage, ADMIN)}
      {pr('/admin/label-designer', LabelDesignerPage, ADMIN)}
      {pr('/admin/report-designer', ReportDesignerPage, ADMIN)}
      {pr('/admin/workflows', WorkflowDesignerPage, ADMIN)}
      {pr('/admin/workflows/:workflowId', WorkflowDesignerPage, ADMIN)}
    </>
  );
}